import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Import jeep-sqlite web component for web platform SQLite support
import { defineCustomElements as jeepSqlite } from 'jeep-sqlite/loader';
import { Capacitor } from '@capacitor/core';

if (environment.production) {
  enableProdMode();
}

// Initialize jeep-sqlite for web platform only
if (!Capacitor.isNativePlatform()) {
  console.log('Initializing SQLite for web platform...');
  
  try {
    // Define the custom elements first
    jeepSqlite(window);
    
    // Create the element with minimal required attributes
    const jeepSqliteEl = document.createElement('jeep-sqlite');
    jeepSqliteEl.setAttribute('autoSave', 'true');
    jeepSqliteEl.setAttribute('wasmPath', 'assets');
    
    // Add comprehensive compatibility layer for missing methods
    (jeepSqliteEl as any).getAvailableSessions = (jeepSqliteEl as any).getAvailableSessions || (() => {
      console.warn('[SQLite] getAvailableSessions not available, using fallback');
      return Promise.resolve({ values: [] });
    });
    
    // Add compatibility layer to the global context as well
    if ((window as any).jeepSqlite) {
      const ctx = (window as any).jeepSqlite;
      if (!ctx.getAvailableSessions) {
        ctx.getAvailableSessions = () => {
          console.warn('[SQLite] Global getAvailableSessions not available, using fallback');
          return Promise.resolve({ values: [] });
        };
      }
    }
    
    document.body.appendChild(jeepSqliteEl);
    
    console.log('jeep-sqlite element added to DOM with comprehensive compatibility layer');
    
  } catch (error) {
    console.error('Failed to initialize jeep-sqlite:', error);
  }
} else {
  console.log('Native platform detected, skipping jeep-sqlite initialization');
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
